import React, { useState, useEffect } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { useLocation } from "react-router-dom";
import instance from "../../../WebApi/WebApi";
import { toast } from "react-toastify";

const NewsDeatils = () => {
  const location = useLocation();
  const slugUrl = new URLSearchParams(location.search).get("slugUrl");
  const [news, setNews] = useState({});

  useEffect(() => {
    if (slugUrl) {
      getNewsById();
    }
  }, [slugUrl]);

  const getNewsById = async () => {
    try {
      const res = await instance.get(
        `customer/common/get-news-details?slugUrl=${slugUrl}`
      );
      setNews(res?.data?.data);
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };
  return (
    <div
      className={
        localStorage.getItem("gs3_AuthToken")
          ? "container-fluid"
          : "container-fluid aboutMain"
      }
    >
      <div className="dbMain">
        <Leftpanel />
        <div className="dbRight">
          <Header link="#" breadcm="" title="News" description="" />
          <div className="commonBase" style={{ padding: "25px" }}>
            {localStorage.getItem("gs3_AuthToken") ? (
              ""
            ) : (
              <h2 className="text-center pb-4">News</h2>
            )}
            <div>
              <img src={news?.image} alt="news" className="newsImagedetails" />
              <h2>{news?.title}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: news?.content }}
                style={{ marginTop: "20px" }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDeatils;
